/* eslint-disable tailwindcss/no-custom-classname */
import { Modal, initialStyles } from '@/components/modal/Modal'
import { isMobile } from 'react-device-detect'

interface Props {
  open: boolean
  onClose: () => void
}

export const RatingModal: React.FC<Props> = ({ open, onClose }) => {
  const modalStyle = {
    ...initialStyles,
    content: {
      ...initialStyles.content,
      width: isMobile ? 'auto' : '600px',
    },
  }

  return (
    <Modal open={open} onRequestClose={() => onClose()} style={modalStyle}>
      <div className="relative p-[10px] font-medium text-white bg-[#4a85c7] border-l-[10px] border-[#3069b0] border-solid">
        <h3 className="p-4 m-[-10px] text-xl leading-6 text-white bg-[#4a85c7]">
          評点基準について
        </h3>
      </div>
      <div className="overflow-y-scroll relative p-[15px] h-[320px] text-[15px]">
        <table className="table mb-0 border border-[#ddd] border-solid">
          <tbody>
            <tr className="bg-[#f9f9f9]">
              <th className="w-1/3 border border-[#ddd] border-solid">
                革新性
              </th>
              <th className="w-1/3 border border-[#ddd] border-solid">
                明瞭性
              </th>
              <th className="w-1/3 border border-[#ddd] border-solid">
                応用性
              </th>
            </tr>
            <tr className="text-[15px]">
              <th className="p-2 font-thin leading-6 text-left align-top border border-[#ddd] border-solid">
                新しいアイデア、または従来のアイデアに新たな視点を提供できているか
              </th>
              <th className="p-2 font-thin leading-6 text-left align-top border border-[#ddd] border-solid">
                用語・図解などの表現や論理構成が読者にわかりやすく提示されているか
              </th>
              <th className="p-2 font-thin leading-6 text-left align-top border border-[#ddd] border-solid">
                日常業務において、読者が書籍の考えや概念を適用することができるか
              </th>
            </tr>
            <tr className="bg-[#f9f9f9]">
              <td className="p-2 leading-6 align-top border border-[#ddd] border-solid">
                <ol className="pl-5 mt-0 mb-[10px]">
                  <li className="list-decimal list-outside">
                    一般的によく知られている従来のビジネス知識の提示にとどまっている。
                  </li>
                  <li className="list-decimal list-outside">
                    従来のビジネスの概念や知識に対して、新たな視点はほとんど見られない。
                  </li>
                  <li className="list-decimal list-outside">
                    従来のビジネスの概念や知識が大部分を占めるが、いくつかの革新的なアプローチや視点を含む。
                  </li>
                  <li className="list-decimal list-outside">
                    新しいメソッド、戦略、概念や視点が内容の大部分を占め、革新性に富む。
                  </li>
                  <li className="list-decimal list-outside">
                    全く新しい洞察や視点、または独自のビジネスイノベーションのアイデアが提示されている。
                  </li>
                </ol>
              </td>
              <td className="p-2 leading-6 align-top border border-[#ddd] border-solid">
                <ol className="pl-5 mt-0 mb-[10px]">
                  <li className="list-decimal list-outside">
                    難解な専門用語、長く複雑な文章、不明瞭な言い回しで書かれているうえ、非論理的。
                  </li>
                  <li className="list-decimal list-outside">
                    難解な専門用語、長く複雑な文章、不明瞭な言い回しが多く、脆弱な論理構成となっている。
                  </li>
                  <li className="list-decimal list-outside">
                    難解な専門用語には適切に注釈が書かれており、明瞭な文章で論理的に構成されている。
                  </li>
                  <li className="list-decimal list-outside">
                    テーマを理解するのに役立つ用語説明、概念の図解を含み、論理構成は良く推敲されている。
                  </li>
                  <li className="list-decimal list-outside">
                    テーマの理解を助ける用語説明や図解に富み、首尾一貫した強力な論理構成が展開されている。
                  </li>
                </ol>
              </td>
              <td className="p-2 leading-6 align-top border border-[#ddd] border-solid">
                <ol className="pl-5 mt-0 mb-[10px]">
                  <li className="list-decimal list-outside">
                    日々の業務に応用できるようなアイデアやコンセプトはほぼ皆無で、理論的な洞察のみにとどまっている。
                  </li>
                  <li className="list-decimal list-outside">
                    理論的な洞察と関連する実際の業務を結びつけるようなアイデアやコンセプトは限定的である。
                  </li>
                  <li className="list-decimal list-outside">
                    理論的な洞察が大部分であるものの、いくつかの事例やチェックリストなどを含み、一定の応用性を有する。
                  </li>
                  <li className="list-decimal list-outside">
                    多くのフレームワーク、チェックシート等のツール、およびケーススタディを伴う応用性の高いコンテンツを有する。
                  </li>
                  <li className="list-decimal list-outside">
                    ビジネスシーンに関連性の高い多くの事例やケーススタディ、実践的なツールを含み、応用性が極めて高い。
                  </li>
                </ol>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="p-[15px] text-center border-none">
        <button
          className="inline-block relative pr-5 mb-0 h-10 text-sm font-normal leading-6 text-center text-white hover:text-white hover:no-underline align-middle whitespace-nowrap bg-[#92949b] hover:bg-[#5e616e] rounded-[52px] border border-b-2 border-[#5e616e] border-solid cursor-pointer"
          onClick={onClose}
        >
          <span className="before:pr-[10px] before:pl-[10px] before:content-['x']">
            閉じる
          </span>
        </button>
      </div>
    </Modal>
  )
}
